import gingerbreadCookieMobile from './staticImages/4744.jpg';
import romanticBoxMobile from './staticImages/4331.jpg';
import maslenitsaBoxMobile from './staticImages/4371.jpg';
import miragoshaBoxMobile from './staticImages/3993.jpg';
import marchBoxMobile from './staticImages/4875.jpg';
import easterBoxMobile from './staticImages/4443.jpg';
import squidgame1 from './staticImages/4974.jpg';
import squidgame2 from './staticImages/4976.jpg';
import squidgame3 from './staticImages/4979.jpg';
import squidgame4 from './staticImages/4980.jpg';
import squidgame5 from './staticImages/4981.jpg';
import squidgame6 from './staticImages/4982.jpg';
import wednesday from './staticImages/5050.jpg';
import halloween from './staticImages/4695_tefal.jpg';
import dacha from './staticImages/4444.jpg';
import sabantuy from './staticImages/5433.jpg';
import school from './staticImages/5505.jpg';

const overrideImagesMap = {
    4744: gingerbreadCookieMobile,
    4331: romanticBoxMobile,
    4371: maslenitsaBoxMobile,
    3993: miragoshaBoxMobile,
    4875: marchBoxMobile,
    4443: easterBoxMobile,
    4982: squidgame6,
    5050: wednesday,
    4695: halloween,
    4444: dacha,
    5433: sabantuy,
    5505: school,
    // 4974: squidgame1,
    // 4976: squidgame2,
    // 4979: squidgame3,
    // 4980: squidgame4,
    // 4981: squidgame5,
};

export const resolveOverrideImage = (id) => (
    id in overrideImagesMap
        ? overrideImagesMap[id]
        : null
);
